import { useSelector } from 'react-redux';

import { vehicleDetailsSelectors } from '@makemydeal/dr-activities-vehicle-details';

export const useHasVehicleDetailsLoaded = (): boolean => {
    const isLoading = useSelector(vehicleDetailsSelectors.getIsLoading);
    const hasData = useSelector(vehicleDetailsSelectors.getHasVehicleData);
    const error = useSelector(vehicleDetailsSelectors.getError);

    return !isLoading && (hasData || error !== null);
};
